import React, { PropsWithChildren } from "react";
import cn from "classnames";

export const Card: React.FC<PropsWithChildren<any>> = ({
  children,
  className,
}) => {
  return (
    <div
      style={{ borderWidth: "1px" }}
      className={cn(
        "rounded-lg dark:border-neutral-700 dark:bg-neutral-700",
        className,
      )}
    >
      {children}
    </div>
  );
};
